import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function PainPointsSection() {
  const painPoints = [{
    title: 'Is Short on Time',
    desc: 'You get home exhausted and the last thing you want is to spend 2 hours in the kitchen.'
  }, {
    title: 'Has a "Picky Eater"',
    desc: 'You battle every day to get a single piece of broccoli into their mouth.'
  }, {
    title: 'Is Stuck in a Rut',
    desc: 'You end up packing the same boring ham sandwich every single day.'
  }, {
    title: 'Wants to Save Money',
    desc: 'You’re tired of spending a fortune on expensive (and unhealthy) packaged snacks.'
  }, {
    title: 'Needs Practicality',
    desc: 'You want meals that can be frozen, prepped ahead, and still taste fresh.'
  }];
  return <section className="bg-gray-50 py-16 px-4" data-id="element-104">
      <div className="max-w-5xl mx-auto" data-id="element-105">
        <div className="text-center mb-12" data-id="element-106">
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#1f2e10] uppercase" data-id="element-107">
            This is ideal for the mom who:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 justify-center" data-id="element-108">
          {painPoints.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 flex flex-col gap-4" data-id="element-109">
              <div className="flex-shrink-0" data-id="element-110">
                <CheckCircle2 className="text-green-500" size={32} data-id="element-111" />
              </div>
              <div data-id="element-112">
                <h3 className="font-bold text-xl text-[#1f2e10] mb-2" data-id="element-113">
                  {point.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-114">{point.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}